import { MAIN_TOKEN_LP_ADDRESS } from "config/constants/exchange";
import { useEffect, useState } from "react";
import { getContract } from "utils/contractHelpers";
import IPancakePair from "config/abi/IPancakePair.json";
import { ChainId } from "@pancakeswap/sdk";
import { provider } from "utils/wagmi";

export default function useTokenPrice() {
    const [stats, setStats] = useState({
        tokenprice: 0,
    });

    useEffect(() => {
        let isMounted = true; // prevents state update after unmount

        const fetchPrice = async () => {
            try {
                const lpContract = getContract(
                    IPancakePair,
                    MAIN_TOKEN_LP_ADDRESS[ChainId.BSC],
                    provider(ChainId.BSC)
                );

                const reserves = await lpContract.getReserves();
                const reserve0 = Number(reserves[0].toString());
                const reserve1 = Number(reserves[1].toString());

                const tokenprice = reserve0 / reserve1;

                if (isMounted) {
                    setStats({ tokenprice });
                }
            } catch (err: any) {
                console.error(err?.message);
            }
        };

        // Initial fetch
        fetchPrice();

        // Refresh every 5 seconds
        const interval = setInterval(fetchPrice, 5000);

        // Cleanup on unmount
        return () => {
            isMounted = false;
            clearInterval(interval);
        };
    }, []);

    return stats;
}
